import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { Button } from '../../../../../components/forms/fields-next';
import { Mode } from '../../../../../components/KendoDataGrid/constants';
import OverflowTooltip from '../../../../../components/OverflowTooltip';
import { Colors } from '../../../../../layout/theme-next';
import { buildSummary } from '../helpers';
import { CustomCellProps } from '../types';

const styles = makeStyles((theme) =>
  createStyles({
    check: {
      color: Colors.success,
      fontWeight: 600,
      marginRight: theme.spacing(0.5),
    },
  }),
);

const SummaryCellTemplate: React.FC<CustomCellProps> = (props) => {
  const classes = styles();
  const { dataItem, onConfigureClick } = props;

  const summary = buildSummary(dataItem.approvalStages);
  const hasStages = dataItem.approvalStages?.length > 0;

  return (
    <Box>
      <Box display="flex" alignItems="center">
        {hasStages && (
          <FontAwesomeIcon icon={solid('check-circle')} className={classes.check} />
        )}

        <OverflowTooltip
          title={summary}
          placement="top"
          arrow
        >
          <Typography
            variant="subtitle2"
            color={hasStages ? 'textPrimary' : 'textSecondary'}
          >
            {summary}
          </Typography>
        </OverflowTooltip>
      </Box>

      {[Mode.edit, Mode.add].includes(dataItem._mode) && <Button
        variant="text"
        size="small"
        onClick={(e) => onConfigureClick?.(dataItem)}
        style={{ padding: 0 }}
      >
        Configure
      </Button>}
    </Box>
  );
};

export default SummaryCellTemplate;
